module.exports = __webpack_public_path__ + "img/facts-teamstore.e7280bd6.svg";